// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [];

export const dictionary = {
		"/": [~5],
		"/about": [6],
		"/calendar": [7],
		"/contact": [8],
		"/events": [~9,[2]],
		"/events/2025/field-day": [10,[2]],
		"/events/2025/may-newbie-field-day-hams-at-park": [11,[2]],
		"/events/2025/winter-field-day": [12,[2]],
		"/events/2026/antenna-build-day": [13,[2]],
		"/events/2026/field-day": [14,[2]],
		"/events/2026/newbie-training-overnight-hangout": [15,[2]],
		"/events/2026/winter-field-day": [16,[2]],
		"/events/2026/worlds-jetboat-championship": [17,[2]],
		"/feeds": [18],
		"/meetings": [19,[3]],
		"/meetings/2025/september-02-general": [20,[3]],
		"/meetings/[year]": [21,[3]],
		"/meetings/[year]/[slug]": [22,[3,4]],
		"/membership": [23],
		"/membership/auxcomm/bylaws": [24],
		"/membership/bylaws": [25],
		"/membership/constitution": [26],
		"/membership/dsarc-inc/bylaws": [27],
		"/nets/auxcomm_ares": [28],
		"/nets/packet": [29],
		"/newsletter": [~30],
		"/resources/repeaters": [~31],
		"/resources/testing": [32],
		"/search": [33]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);